import { Routes } from "@angular/router";
import { AuthGuard } from "../../_helper/auth.guard";
import { Role } from "../../_models/role";
const userRole = sessionStorage.getItem("userRole");

export const content: Routes = [
  {
    path: "adminhkbkcms/dashboard",
    loadChildren: () =>
      import("../../components/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
    data: {
      // // roles: [userRole.search('Dashboard') != -1 ? Role.Dashboard : '']
    }
  },
  {
    path: "adminhkbkcms/testimonials",
    loadChildren: () =>
      import("../../components/testimonials/testimonials.module").then(
        (m) => m.TestimonialsModule
      ),
    data: {
      breadcrumb: "Master"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/hkbkfacilities-heading",
    loadChildren: () =>
      import(
        "../../components/hkbkfacilities-heading/hkbkfacilities-heading.module"
      ).then((m) => m.HkbkfacilitiesHeadingModule),
    data: {
      breadcrumb: "HKBK Facilities Heading"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/hkbkfacilities",
    loadChildren: () =>
      import("../../components/hkbkfacilities/hkbkfacilities.module").then(
        (m) => m.HkbkfacilitiesModule
      ),
    data: {
      breadcrumb: "HKBK Facilities"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/gallery-heading",
    loadChildren: () =>
      import("../../components/gallery-heading/gallery-heading.module").then(
        (m) => m.GalleryHeadingModule
      ),
    data: {
      breadcrumb: "Gallery Heading"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/gallery",
    loadChildren: () =>
      import("../../components/gallery/gallery.module").then(
        (m) => m.GalleryModule
      ),
    data: {
      breadcrumb: "Yoga"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/yoga",
    loadChildren: () =>
      import("../../components/yoga/yoga.module").then(
        (m) => m.YogaModule
      ),
    data: {
      breadcrumb: "yoga"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },

  
  {
    path: "adminhkbkcms/faculty-department",
    loadChildren: () =>
      import(
        "../../components/faculty-department/faculty-department.module"
      ).then((m) => m.FacultyDepartmentModule),
    data: {
      breadcrumb: "Faculty Department"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/library",
    loadChildren: () =>
      import("../../components/library/library.module").then(
        (m) => m.LibraryModule
      ),
    data: {
      breadcrumb: "Library"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/insurance",
    loadChildren: () =>
      import("../../components/insurance/insurance.module").then(
        (m) => m.InsuranceModule
      ),
    data: {
      breadcrumb: "Insurance"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/objective",
    loadChildren: () =>
      import("../../components/objective/objective.module").then(
        (m) => m.ObjectiveModule
      ),
    data: {
      breadcrumb: "Objective"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/messages",
    loadChildren: () =>
      import("../../components/messages/messages.module").then(
        (m) => m.MessagesModule
      ),
    data: {
      breadcrumb: "Messages"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/achievements",
    loadChildren: () =>
      import("../../components/achievements/achievements.module").then(
        (m) => m.AchievementsModule
      ),
    data: {
      breadcrumb: "Achievements"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/upcomingevents",
    loadChildren: () =>
      import("../../components/upcomingevents/upcomingevents.module").then(
        (m) => m.UpcomingeventsModule
      ),
    data: {
      breadcrumb: "Upcomingevents"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/alumni-feedback",
    loadChildren: () =>
      import("../../components/alumni-feedback/alumni-feedback.module").then(
        (m) => m.AlumniFeedbackModule
      ),
    data: {
      breadcrumb: "Alumni Feedback"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/course-feedback",
    loadChildren: () =>
      import("../../components/course-feedback/course-feedback.module").then(
        (m) => m.CourseFeedbackModule
      ),
    data: {
      breadcrumb: "Course Feedback"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/infrastructure-feedback",
    loadChildren: () =>
      import(
        "../../components/infrastructure-feedback/infrastructure-feedback.module"
      ).then((m) => m.InfrastructureFeedbackModule),
    data: {
      breadcrumb: "Infrastructure Feedback"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/parents-feedback",
    loadChildren: () =>
      import("../../components/parents-feedback/parents-feedback.module").then(
        (m) => m.ParentsFeedbackModule
      ),
    data: {
      breadcrumb: "Parents Feedback"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/aboutbrowseby",
    loadChildren: () =>
      import("../../components/browsebyabout/browsebyabout.module").then(
        (m) => m.BrowsebyaboutModule
      ),
    data: {
      breadcrumb: "Master"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/how-to-apply",
    loadChildren: () =>
      import("../../components/how-to-apply/how-to-apply.module").then(
        (m) => m.HowToApplyModule
      ),
    data: {
      breadcrumb: "Admissions"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/news-year",
    loadChildren: () =>
      import("../../components/news-year/news-year.module").then(
        (m) => m.NewsYearModule
      ),
    data: {
      breadcrumb: "News-Year"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/students-achievements",
    loadChildren: () =>
      import(
        "../../components/students-achievements/students-achievements.module"
      ).then((m) => m.StudentsAchievementsModule),
    data: {
      breadcrumb: "Students Achievements"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/department-spotlight",
    loadChildren: () =>
      import(
        "../../components/department-spotlight/department-spotlight.module"
      ).then((m) => m.DepartmentSpotlightModule),
    data: {
      breadcrumb: "Department Spotlight"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/indian-students",
    loadChildren: () =>
      import("../../components/indian-students/indian-students.module").then(
        (m) => m.IndianStudentsModule
      ),
    data: {
      breadcrumb: "Admissions"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/international-students",
    loadChildren: () =>
      import(
        "../../components/international-students/international-students.module"
      ).then((m) => m.InternationalStudentsModule),
    data: {
      breadcrumb: "Admissions"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/colleges',
    loadChildren: () => import('../../components/colleges/colleges.module').then(m => m.CollegesModule),
    data: {
      breadcrumb: "Master"
    }
  }, */
  /* {
    path: 'adminhkbkcms/collegeinfo',
    loadChildren: () => import('../../components/products/products.module').then(m => m.ProductsModule),
    data: {
      breadcrumb: "Collegeinfo",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  }, */
  /* {
    path: 'adminhkbkcms/sales',
    loadChildren: () => import('../../components/sales/sales.module').then(m => m.SalesModule),
    data: {
      breadcrumb: "Sales",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/coupons',
    loadChildren: () => import('../../components/coupons/coupons.module').then(m => m.CouponsModule),
    data: {
      breadcrumb: "Coupons"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/pages",
    loadChildren: () =>
      import("../../components/pages/pages.module").then((m) => m.PagesModule),
    data: {
      breadcrumb: "Pages"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/sections",
    loadChildren: () =>
      import("../../components/section/section.module").then(
        (m) => m.SectionModule
      ),
    data: {
      breadcrumb: "Sections"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/placementsnews',
    loadChildren: () => import('../../components/placementsnews/placementsnews.module').then(m => m.PlacementsnewsModule),
    data: {
      breadcrumb: "Placements News",
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/news",
    loadChildren: () =>
      import("../../components/news/news.module").then((m) => m.NewsModule),
    data: {
      breadcrumb: "News"
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/course",
    loadChildren: () =>
      import("../../components/courses/course.module").then(
        (m) => m.CourseModule
      ),
    data: {
      breadcrumb: "Course"
      // roles: [Role.Admin, Role.CivilEngineering, Role.ComputerScienceEngineering, Role.Degree, Role.ElectronicsEngineering, Role.InformationScienceEngineering, Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/fees",
    loadChildren: () =>
      import("../../components/fees/fees.module").then((m) => m.FeesModule),
    data: {
      breadcrumb: "Fees"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/curriculum",
    loadChildren: () =>
      import("../../components/curriculum/curriculum.module").then(
        (m) => m.CurriculumModule
      ),
    data: {
      breadcrumb: "Curriculum"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/eligibility",
    loadChildren: () =>
      import("../../components/eligibility/eligibility.module").then(
        (m) => m.EligibilityModule
      ),
    data: {
      breadcrumb: "Eligibility"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/moredetails",
    loadChildren: () =>
      import("../../components/moredetails/moredetails.module").then(
        (m) => m.MoredetailsModule
      ),
    data: {
      breadcrumb: "Moredetails"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'adminhkbkcms/blogs',
    loadChildren: () => import('../../components/blogs/blogs.module').then(m => m.BlogsModule),
    data: {
      breadcrumb: "Blogs",
    },
    canActivate: [AuthGuard],
  },
  {
    path: "adminhkbkcms/placements",
    loadChildren: () =>
      import("../../components/placements/placements.module").then(
        (m) => m.PlacementsModule
      ),
    data: {
      breadcrumb: "Recruiters"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/homecontents",
    loadChildren: () =>
      import("../../components/homebannermenu/homebannermenu.module").then(
        (m) => m.HomebannermenuModule
      ),
    data: {
      breadcrumb: "Home"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },

  /* {
    path: 'adminhkbkcms/advancedengineering',
    loadChildren: () => import('../../components/advancedengineering/advancedengineering.module').then(m => m.AdvancedengineeringModule),
    data: {
      breadcrumb: "Home"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/institutions",
    loadChildren: () =>
      import("../../components/institutions/institutions.module").then(
        (m) => m.InstitutionsModule
      ),
    data: {
      breadcrumb: "Institutions"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/placements-overview",
    loadChildren: () =>
      import("../../components/hkbkplacements/hkbkplacements.module").then(
        (m) => m.HkbkplacementsModule
      ),
    data: {
      breadcrumb: "Placements Overview"
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/placements-otherinfo",
    loadChildren: () =>
      import(
        "../../components/hkbkplacements-otherinfo/hkbkplacements-otherinfo.module"
      ).then((m) => m.PlacementsOtherinfoModule),
    data: {
      breadcrumb: "Placements Otherinfo"
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/academics',
    loadChildren: () => import('../../components/academics/academics.module').then(m => m.AcademicsModule),
    data: {
      breadcrumb: "Academics"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/faculty",
    loadChildren: () =>
      import("../../components/faculty/faculty.module").then(
        (m) => m.FacultyModule
      ),
    data: {
      breadcrumb: "Faculty"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/students-placed",
    loadChildren: () =>
      import(
        "../../components/hkbkplacements-students-placed/hkbkplacements-students-placed.module"
      ).then((m) => m.PlacementsStudentsPlacedModule),
    data: {
      breadcrumb: "Students Placed"
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/aboutusoverview",
    loadChildren: () =>
      import("../../components/aboutus-overview/aboutus-overview.module").then(
        (m) => m.AboutusOverviewModule
      ),
    data: {
      breadcrumb: "About Us Overview"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/rankings",
    loadChildren: () =>
      import("../../components/rankings/rankings.module").then(
        (m) => m.RankingsModule
      ),
    data: {
      breadcrumb: "Rankings"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/leadership",
    loadChildren: () =>
      import("../../components/leadership/leadership.module").then(
        (m) => m.LeadershipModule
      ),
    data: {
      breadcrumb: "Leadership"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/committes',
    loadChildren: () => import('../../components/committes/committes.module').then(m => m.CommittesModule),
    data: {
      breadcrumb: "Committes"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/studentstories",
    loadChildren: () =>
      import("../../components/studentstories/studentstories.module").then(
        (m) => m.StudentstoriesModule
      ),
    data: {
      breadcrumb: "Studentstories"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/campus",
    loadChildren: () =>
      import("../../components/campus/campus.module").then(
        (m) => m.CampusModule
      ),
    data: {
      breadcrumb: "Campus"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/club-type",
    loadChildren: () =>
      import("../../components/club-type/club-type.module").then(
        (m) => m.ClubTypeModule
      ),
    data: {
      breadcrumb: "Club TYpe"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/facility",
    loadChildren: () =>
      import("../../components/facility/facility.module").then(
        (m) => m.FacilitiyModule
      ),
    data: {
      breadcrumb: "Facility"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/facilitiesoverview",
    loadChildren: () =>
      import(
        "../../components/facilitiesoverview/facilitiesoverview.module"
      ).then((m) => m.FacilitiesoverviewModule),
    data: {
      breadcrumb: "Campus"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/homeranksection",
    loadChildren: () =>
      import("../../components/homeranksection/homeranksection.module").then(
        (m) => m.HomeRankSectionModule
      ),
    data: {
      breadcrumb: "Home Rank Section"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/filespath",
    loadChildren: () =>
      import("../../components/files-path/files-path.module").then(
        (m) => m.FilespathModule
      ),
    data: {
      breadcrumb: "Files Path"
      // roles: [Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/homeslider",
    loadChildren: () =>
      import("../../components/home-slider/home-slider.module").then(
        (m) => m.HomeSliderModule
      ),
    data: {
      breadcrumb: "Home Slider"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/institutionsslider",
    loadChildren: () =>
      import(
        "../../components/institutions-slider/institutions-slider.module"
      ).then((m) => m.InstitutionsSliderModule),
    data: {
      breadcrumb: "Institutions Slider"
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/rankingheading',
    loadChildren: () => import('../../components/rankings-heading/rankings-heading.module').then(m => m.RankingsHeadingModule),
    data: {
      breadcrumb: "Ranking Recognition Heading"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/iqacheading",
    loadChildren: () =>
      import("../../components/iqacheading/iqacheading.module").then(
        (m) => m.IqacHeadingModule
      ),
    data: {
      breadcrumb: "IQAC Heading"
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/iqacsubheading",
    loadChildren: () =>
      import("../../components/iqac-subheading/iqac-subheading.module").then(
        (m) => m.IqacSubHeadingModule
      ),
    data: {
      breadcrumb: "IQAC Sub Heading"
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/iqaccontent",
    loadChildren: () =>
      import("../../components/iqac-content/iqac-content.module").then(
        (m) => m.IqacContentModule
      ),
    data: {
      breadcrumb: "IQAC Content"
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/iic",
    loadChildren: () =>
      import(
        "../../components/institute-industry-connect/institute-industry-connect.module"
      ).then((m) => m.IICModule),
    data: {
      breadcrumb: "Institute Industry Connect"
      // roles: [Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/learning-resources",
    loadChildren: () =>
      import(
        "../../components/learning-resources/learning-resources.module"
      ).then((m) => m.LearningResourcesModule),
    data: {
      breadcrumb: "Learning Resources"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/learning-resources-uploads",
    loadChildren: () =>
      import(
        "../../components/learning-resources-uploads/learning-resources-uploads.module"
      ).then((m) => m.LearningResourcesUploadsModule),
    data: {
      breadcrumb: "Learning Resources Uploads"
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/media",
    loadChildren: () =>
      import("../../components/media/media.module").then((m) => m.MediaModule),
    data: {
      breadcrumb: "Media"
      // // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering,Role.NAAC, Role.Placement],
    },
    canActivate: [AuthGuard]
  },
  /* {
    path: 'adminhkbkcms/menus',
    loadChildren: () => import('../../components/menus/menus.module').then(m => m.MenusModule),
    data: {
      breadcrumb: "Menus"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: "adminhkbkcms/users",
    loadChildren: () =>
      import("../../components/users/users.module").then((m) => m.UsersModule),
    data: {
      breadcrumb: "Users"
      // // roles: [Role.Admin],
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/settings",
    loadChildren: () =>
      import("../../components/setting/setting.module").then(
        (m) => m.SettingModule
      ),
    data: {
      breadcrumb: "Settings"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/institutions-info",
    loadChildren: () =>
      import(
        "../../components/institutions-info/institutions-info.module"
      ).then((m) => m.InstitutionsInfoModule),
    data: {
      breadcrumb: "Settings"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/recruiter",
    loadChildren: () =>
      import("../../components/recruiter/recruiter.module").then(
        (m) => m.RecruiterModule
      ),
    data: {
      breadcrumb: "Recruiter"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/homepage-overview",
    loadChildren: () =>
      import(
        "../../components/homepage-overview/homepage-overview.module"
      ).then((m) => m.HomepageOverviewModule),
    data: {
      breadcrumb: "Homepage Overview"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/campus-news-events",
    loadChildren: () =>
      import(
        "../../components/campus-news-events/campus-news-events.module"
      ).then((m) => m.CampusNewsEventsModule),
    data: {
      breadcrumb: "Campus News Events"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/naac-heading",
    loadChildren: () =>
      import("../../components/naac-heading/naac-heading.module").then(
        (m) => m.NaacHeadingModule
      ),
    data: {
      breadcrumb: "Naac Heading"
    },
    canActivate: [AuthGuard]
  },
  {
    path: "adminhkbkcms/naac-sub-heading",
    loadChildren: () =>
      import("../../components/naac-sub-heading/naac-sub-heading.module").then(
        (m) => m.NaacSubHeadingModule
      ),
    data: {
      breadcrumb: "Naac Sub Heading"
    },
    canActivate: [AuthGuard]
  }
  /* {
    path: 'adminhkbkcms/vendors',
    loadChildren: () => import('../../components/vendors/vendors.module').then(m => m.VendorsModule),
    data: {
      breadcrumb: "College"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/localization',
    loadChildren: () => import('../../components/localization/localization.module').then(m => m.LocalizationModule),
    data: {
      breadcrumb: "Localization"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/reports',
    loadChildren: () => import('../../components/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/invoice',
    loadChildren: () => import('../../components/invoice/invoice.module').then(m => m.InvoiceModule),
    data: {
      breadcrumb: "Invoice"
    },
    canActivate: [AuthGuard],
  }, */
];
